import { TWO, ZERO } from '@constants';
import { Box, styled } from '@mui/material';

interface StyledBox {
  index?: number;
}

export const StyledBox = styled(Box)<StyledBox>(({ index, theme: { palette } }) => ({
  backgroundColor: index && index % TWO !== ZERO ? palette.background.default : palette.background.paper,
}));
